<template>
    <table class="table table-sm table-striped">
        <thead class="thead-dark">
        <tr>
            <th><small>(Helpline Area Pages Only)</small></th>
            <th>Total Page Views</th>
        </tr>
        </thead>
        <tr>
            <td>Scheme To Date</td>
            <td>{{ context.pageviews.all.total }}</td>
        </tr>
        <tr>
            <td>{{ monthName }} {{ year }}</td>
            <td>{{ context.pageviews.month.total }}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "ReportPageviews",
        props: ['context','year','monthName']
    }
</script>

<style scoped>

</style>
